import * as React from 'react';
import MetaTags from 'react-meta-tags';



export class MetaTagsComponent extends React.Component {

    render() {
        const firstOnboardingPage = 'http://crxmouse-staging-server.us-east-1.b2c-productivity-group.serving.int.blocksite.co/the-mouse-chase-1';
        return (
            <MetaTags>
                <meta property='og:url' content={firstOnboardingPage}/>
            </MetaTags>
        );
    }
}
